import { Injectable } from '@angular/core';
import { ResponseMessage } from '../models/responseMessage/responseMessage.model';
import { ToastDirective } from '../../shared/directives/toast/toast';
import { LoadingService } from './loading.service';

@Injectable()
export class MessageService {
  constructor(
    public toast: ToastDirective,
    public loadingService: LoadingService
  ) { }

  parseError(errors: any, formErrors, hasError = false) {
    const data = errors.children;

    if (data) {
      for (const field in data) {
        if (data.hasOwnProperty(field)) {
          // clear previous error message (if any)
          if (data[field].hasOwnProperty('children')) {
            const child = Object.assign({}, this.parseError(data[field], {}, hasError));
            hasError = child.hasError;
            formErrors[field] = Object.assign({}, child.formErrors);
          }

          if (data[field].hasOwnProperty('errors')) {
            hasError = true;
            // set the messages
            formErrors[field] = data[field].errors.join(' ');
          }
        }
      }
    }

    return {
      formErrors: formErrors,
      hasError: hasError
    };
  }

  handleError(data) {
    try {
      const siteResponse: ResponseMessage = data.json();
      let message;
      let errors: any = {};

      if ('errors' in siteResponse && siteResponse.errors) {
        // Parse errors linked to form fields
        errors = this.parseError(siteResponse.errors, {});

        // Specific error handling for global form errors
        if (true === siteResponse.errors.hasOwnProperty('errors') && siteResponse.errors['errors'].length !== 0) {
          siteResponse.message = siteResponse.errors['errors'].join(' ');
        }
      }
      if (
        !errors.hasError &&
        'message' in siteResponse &&
        siteResponse.message !== ''
      ) {
        message = siteResponse.message;
      } else {
        message = 'Certains champs semblent invalides, merci de vérifier les messages en rouge dans votre écran.';
      }
      this.toast.createAdv({ message, type: 'error' });
      this.loadingService.end();

      return {
        formErrors: errors.formErrors,
        message: message
      };
    } catch (e) {
      this.loadingService.end();
      return {
        formErrors: {},
        message: null
      };
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/services/message.service.ts